// src/modules/app-views/crm/pages/Kanban/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { PlusOutlined } from '@ant-design/icons';
import { fromAuthStore } from 'stores/auth';
import { fromAppStore } from 'stores/app';
import { test, USER_ROLE } from '../../../roleConfig';

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************
const crmKanbanActionButton = () => {
  return {
    action: 'new',
    label: 'new_column',
    tooltip: 'add_column',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    // Visible getter: evaluated on each ActionsButton render so it reacts to board changes.
    // For admin/owner the button is always visible.
    // For guests it respects the board's allowNewColumns permission.
    get visible() {
      const profile = fromAuthStore(s => s.subscription?.profile);
      const role = test ? USER_ROLE : (profile || 'guest');
      if (role !== 'guest') return true;

      const urlMatch = window.location.pathname.match(/\/board\/([^/]+)/);
      const boardUid = urlMatch?.[1];
      if (!boardUid) return true;

      const boards = fromAppStore(s => s.parameters?.modules?.crm?.boards) || [];
      const board = boards.find(b => b.uid === boardUid);
      return board?.allowNewColumns !== false;
    },

    // Dispatch event so CrmKanban handles the optimistic update internally
    onClick: () => {
      window.dispatchEvent(new CustomEvent('crm:kanban:add-column'));
    },

    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default crmKanbanActionButton;
